/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../hooks/useNotification.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDataAuth } from '../../../hooks/useDataAuth.js';
import { useForm } from '../../../hooks/useForm.js';
import { useTranslation } from "react-i18next";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import moment from 'moment';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient.js';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany.js';
import { DialogEmailRecipients } from '../../../components/invoice/dialogs/DialogEmailRecipients.jsx';
import { ActionButtons } from '../../../components/others/ActionButtons.js';
import LoadingOverlay from '../../../components/others/LoadingOverlay.js';
import { DebitNoteForm } from '../components/DebitNoteForm.js';
import { AssociatedInvoice } from '../components/AssociatedInvoice.js';
import { DianErrorsDialog } from '../../../components/invoice/shared/Dialogs/DianErrorsDialog.jsx';
import { ProductsForm } from '../../../components/invoice/shared/ProductsForm.js';
import { ClientForm } from '../../../components/invoice/shared/ClientForm.js';
import { Supplier } from '../../../components/invoice/shared/Supplier.js';
import { getAccessScreen } from '../../../services/common.services.js';
import { insert, getCompanies, update, fetchInvoiceId, fetchProductsInvoice } from "../../../services/invoice.services.js";
import { PreviewDocument } from '../../../components/invoice/dialogs/PreviewDocument.jsx';
import { useElectronicDocument } from '../../../hooks/useElectronicDocument.js';
import { useEmailRecipients } from '../../../hooks/useEmailRecipients.js';

const model = {
    prefix: 'ND',
    id_company: '',
    id_company_supplier: '',
    company_supplier_name: '',
    id_company_receiver: '',
    id_office_receiver: '',
    address_delivery: '',
    currency: 'COP',
    other_currency: 'COP',
    products: [],
    id_payment_method: '',
    id_mean_of_payment: '',
    mean_of_payment_text: '',
    customization_id: '30',
    document_type_code: '92',
    retentions: [],
    ica_retention_rate: '',
    exchange_rate: 0,
    total_retentions: '',
    gross_total_value_other: '',
    retentions_total_other: '',
    payable_amount_other: '',
    incoterms_id: '',
    incoterms: '',
    transportation_payment: 0,
    order_reference: '',
    document_id_referenced: '',
    uuid_referenced: '',
    concept_correction_id: '',
    concept_correction: '',
    discount_other: '',
    resolution: '',
    observations: '',
    status_code: 'SAVED',
    created: '',
    updated: '',
    start_period_date: moment(new Date()).format('YYYY/MM/DD'),
    end_period_date: moment(new Date()).format('YYYY/MM/DD'),
    expedition_date_referenced: moment(new Date()).format('YYYY/MM/DD'),
    issue_date: moment(new Date()).format('YYYY/MM/DD'),
    order_reference_date: moment(new Date()).format('YYYY/MM/DD'),
    payment_due_date: moment(new Date()).format('YYYY/MM/DD'),
    expedition_date: moment(new Date()).format('YYYY/MM/DD'),
    exchange_rate_date: moment(new Date()).format('YYYY/MM/DD'),
    email_recipients: '',
};

export const LayoutDebitNote = () => {
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();

    // ── hooks ─────────────────────────────────────────────────────────────────
    const { openPreviewDialog, pdfBase64, handleClosePreviewDialog, getPreviewDocument } = useElectronicDocument();

    const {
        openEmailDialog,
        openDialog: openEmailDialogFn,
        closeDialog: closeEmailDialog,
        catalogue,
        selected,
        newEmail,
        newEmailError,
        handleNewEmailChange,
        addEmail,
        handleSelectChange,
        handleRemoveChip,
        confirmAndSend,
    } = useEmailRecipients();

    // ── refs ──────────────────────────────────────────────────────────────────
    const productsFormRef   = useRef();
    const associatedFormRef = useRef();
    const clientmRef        = useRef();
    const invoiceRef        = useRef();

    // ── local state ───────────────────────────────────────────────────────────
    const [invoiceData, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(model);
    const [loading, setLoading]                     = useState(false);
    const [edit, setEdit]                           = useState(false);
    const [isView, setIsView]                       = useState(false);
    const [companies, setCompanies]                 = useState([]);
    const [refreshTotals, setRefreshTotals]         = useState(null);
    const [supplierId, setSupplierId]               = useState('');
    const [errorDian, setErrorDian]                 = useState(false);
    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    const [changeValueAccess, setChangeValueAccess] = useState(false);

    // ── data fetching ─────────────────────────────────────────────────────────
    const fetchInvoiceData = useCallback(async (idInvoice) => {
        try {
            const [InvoiceRes, productsRes] = await Promise.all([
                fetchInvoiceId(idInvoice, userSession.token),
                fetchProductsInvoice(idInvoice, userSession.token)
            ]);
            if (InvoiceRes.status === 200 && productsRes.status === 200) {
                if (InvoiceRes?.data?.[0]) {
                    const invoice = InvoiceRes.data[0];
                    const parseDate = (dateStr) =>
                        dateStr ? moment(dateStr.split('T')[0], 'YYYY-MM-DD').toDate() : null;
                    const order = {
                        ...invoice,
                        retentions: invoice.retentions ? invoice.retentions.split(',') : [],
                        payment_due_date:          parseDate(invoice.payment_due_date),
                        expedition_date:           parseDate(invoice.expedition_date),
                        order_reference_date:      parseDate(invoice.order_reference_date),
                        issue_date:                parseDate(invoice.issue_date),
                        exchange_rate_date:        parseDate(invoice.exchange_rate_date),
                        products: productsRes.data || []
                    };
                    setAllInfo(order);
                    setSupplierId(order.id_company_supplier || '');
                    setEdit(true);
                    setLoading(false);
                } else {
                    console.error("Error uploading data");
                }
            }
        } catch (error) {
            console.error("Error fetching opportunity data:", error);
        }
    }, [userSession.token]);

    useEffect(() => {
        if (location.state && location.state.config) {
            const { data } = location.state.config || {};
            if (data?.work_flow === 'FLOW_PROCESS-VIEW_ORDER_REFERENCE') setIsView(true);

            if (data?.id) {
                setEdit(true);
                setLoading(true);
                setOpenDialogCompany(false);
                fetchInvoiceData(data.id);
            } else {
                const fetchData = async () => {
                    try {
                        setLoading(true);
                        const response = await getCompanies('MENU-DEDIT_NOTE', userSession.token);
                        setCompanies(response.data || []);
                        if (response.data && response.data.length === 1) {
                            setSupplierData(response.data[0]);
                            setOpenDialogCompany(false);
                        } else {
                            setOpenDialogCompany(true);
                        }
                    } catch (err) {
                        console.log(err.message);
                    } finally {
                        setLoading(false);
                    }
                };
                fetchData();
            }
        }
    }, [location.state, userSession.token, fetchInvoiceData]);

    useEffect(() => {
        if (invoiceData.id_company) {
            (async () => {
                try {
                    const response = await getAccessScreen('MENU-DEBIT_NOTE', invoiceData.id_company, userSession.token);
                    if (response.status === 200 && response?.data?.[0]) {
                        const data = response.data[0];
                        const check = (i) => { if (i.work_flow === 'ACCESS-CHANGE-VALUE') setChangeValueAccess(true); };
                        Array.isArray(data) ? data.forEach(check) : check(data);
                    }
                } catch (err) {
                    console.error(err.message);
                }
            })();
        }
    }, [invoiceData.id_company, userSession.token]);

    // ── form validation ───────────────────────────────────────────────────────
    const isValidForm = async () => {
        const isCreatingProduct = !productsFormRef.current?.getData().some(p => p.isCreated);
        const validations = await Promise.all([
            clientmRef.current?.validForm(),
            invoiceRef.current?.validForm(),
            associatedFormRef.current?.validForm(),
            productsFormRef.current?.validForm(),
            Promise.resolve(isCreatingProduct),
        ]);
        return { allValid: validations.every(Boolean), isCreatingProduct };
    };

    const notifyInvalid = (isCreatingProduct) => {
        sendNotification({
            msg: t(isCreatingProduct ? 'validation.requiredFieldsMissing' : 'validation.unsavedChanges'),
            variant: 'error',
        });
    };

    // ── DIAN response handler ─────────────────────────────────────────────────
    const handleResponseSend = async (response) => {
        if (
            response?.status === 200 &&
            response?.data?.StatusCode !== '00' &&
            response?.data?.ErrorMessage?.length > 0
        ) {
            setErrorDian(response.data);
        } else {
            sendNotification({ msg: t('messages.processRunning'), variant: 'success' });
            Cancel();
        }
    };

    // ── Guardar + Preview ─────────────────────────────────────────────────────
    const handleSubmit = async () => {
        const { allValid, isCreatingProduct } = await isValidForm();
        if (!allValid) { notifyInvalid(isCreatingProduct); return; }

        setLoading(true);
        const action = 'CREATE_JSON_DIAN_DEBINOTE';
        const json   = {
            ...invoiceData,
            retentions: invoiceData.retentions.join(','),
            document_id: `${invoiceData.prefix}${invoiceData.document_id}`,
        };
        const data = JSON.stringify(json);

        try {
            if (edit) {
                const response = await update(data, userSession.token);
                if (response?.status === 200 && response?.data?.[0])
                    getPreviewDocument(invoiceData.id_electronic_document, action);
            } else {
                const response = await insert(userSession.token, data);
                if (response?.status === 200 && response?.data?.[0])
                {
                    const newId = response.data[0].id;
                    handleDirectInputChange('id_electronic_document', newId);
                    setEdit(true);
                    await getPreviewDocument(newId, action);
                }
            }
        } finally {
            setLoading(false);
        }
    };

    // ── Enviar (abre dialog de destinatarios) ─────────────────────────────────
    const handleSubmitSend = async () => {
        const { allValid, isCreatingProduct } = await isValidForm();
        if (!allValid) { notifyInvalid(isCreatingProduct); return; }

        setLoading(true);
        try {
            await openEmailDialogFn(invoiceData.id_office_receiver);
        } finally {
            setLoading(false);
        }
    };

    // ── Confirmar destinatarios → enviar a DIAN ───────────────────────────────
    const handleEmailConfirm = async () => {
        confirmAndSend({
            invoiceData: {
                ...invoiceData,
                document_id: `${invoiceData.prefix}${invoiceData.document_id}`,
            },
            edit,
            handleDirectInputChange,
            handleResponseSend,
            setLoading,
            action: 'CREATE_JSON_DIAN_DEBINOTE',
        });
    };

    // ── helpers ───────────────────────────────────────────────────────────────
    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1);
    };

    const handleConfirmAction = useCallback((dto) => {
        setSupplierData(dto);
        setOpenDialogCompany(false);
    }, []);

    const setSupplierData = (dto) => {
        handleDirectInputChange('id_company',            dto.id_company  || '');
        handleDirectInputChange('company_supplier_name', dto.name        || '');
        handleDirectInputChange('id_company_supplier',   dto.id_number   || '');
        setSupplierId(dto.id_number || '');
    };

    // ── render ────────────────────────────────────────────────────────────────
    return (
        <>
            <Box sx={{ width: '90%', mx: 'auto' }}>
                <Typography variant="h4" gutterBottom>
                    {isView
                        ? t('debitNote.title')
                        : `${edit ? t('edit') : t('create')} ${t('debitNote.title')}`}
                </Typography>
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>{t('suppliers.supplierInofo')}</Typography>
                        <Supplier dto={invoiceData} />
                        <DividerGradient />

                        <AssociatedInvoice
                            ref={associatedFormRef}
                            dto={invoiceData}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                        />
                        <DividerGradient />

                        <Typography variant="h6" gutterBottom>{t('client.clientInfo')}</Typography>
                        <ClientForm
                            ref={clientmRef}
                            handleFieldChange={handleInputChange}
                            handleDirectChange={handleDirectInputChange}
                            isEdit={edit}
                            dto={invoiceData}
                        />
                        <DividerGradient />

                        <Typography variant="h6" gutterBottom>{t('debitNote.infoDebitNote')}</Typography>
                        <DebitNoteForm
                            ref={invoiceRef}
                            supplierId={supplierId}
                            setRefreshTotals={setRefreshTotals}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={invoiceData || {}}
                        />

                        <DividerGradient />

                        <Typography variant="h6" gutterBottom>{t('crm.products.title')}</Typography>
                        <ProductsForm
                            ref={productsFormRef}
                            handleDirectInputChange={handleDirectInputChange}
                            handleInputChange={handleInputChange}
                            refreshTotals={refreshTotals}
                            dto={invoiceData}
                            changeValueAccess={changeValueAccess}
                        />

                        <ActionButtons
                            onCancel={Cancel}
                            onSubmit={handleSubmit}
                            submitLabel={t('savePreview')}
                            onSubmitOptional={handleSubmitSend}
                            disabledSubmit={isView}
                            labelOptional={t("send")}
                            disabledOptional={isView || (edit && invoiceData.status_code === 'APR')}
                        />
                    </CardContent>
                </Card>
            </Box>

            {loading && <LoadingOverlay isOpen={loading} />}

            {openDialogCompany && (
                <DialogSelectCompany
                    openDialogConfirm={openDialogCompany}
                    handleCancelConfirm={Cancel}
                    handleConfirmAction={handleConfirmAction}
                    data={companies}
                />
            )}

            {/* ── email recipients dialog (driven by useEmailRecipients) ── */}
            <DialogEmailRecipients
                open={openEmailDialog}
                onClose={closeEmailDialog}
                onConfirm={handleEmailConfirm}
                catalogue={catalogue}
                selected={selected}
                newEmail={newEmail}
                newEmailError={newEmailError}
                onNewEmailChange={handleNewEmailChange}
                onAddEmail={addEmail}
                onSelectChange={handleSelectChange}
                onRemoveChip={handleRemoveChip}
            />

            {/* ── PDF preview dialog ── */}
            <PreviewDocument
                open={openPreviewDialog}
                pdfBase64={pdfBase64}
                setOpen={handleClosePreviewDialog}
            />

            {(errorDian && errorDian?.ErrorMessage) && (
                <DianErrorsDialog dianResponse={errorDian} onClose={() => setErrorDian(false)} />
            )}
        </>
    );
};